import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/ViewUser.css";

const ViewUser = () => {

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  const BASE_URL = "https://ctmapi.zerlak.com/api/v1/settings/users";

  // FETCH USERS
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${BASE_URL}/getAllUsers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      const data = await response.json();
      setUsers(data);

    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // DELETE USER
  const deleteUser = async (id) => {

    const confirmDelete = window.confirm("Delete this user?");
    if (!confirmDelete) return;

    try {

      await fetch(`${BASE_URL}/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      fetchUsers();

    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  // TOGGLE STATUS
  const toggleStatus = async (username, active) => {

    try {

      await fetch(
        `${BASE_URL}/${username}/status?active=${!active}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      fetchUsers();

    } catch (error) {
      console.error("Status update failed:", error);
    }
  };

  // SEARCH FILTER
  const filteredUsers = users.filter((user) =>
    user.username?.toLowerCase().includes(search.toLowerCase()) ||
    user.role?.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    fetchUsers();
  }, []);

  return (

    <div className="view-user-container">

      <div className="view-user-card">

        {/* HEADER */}

        <div className="view-user-header">

          <h2>User Management</h2>

          <button
            className="btn-add-user"
            onClick={() => navigate("/dashboard/create-user")}
          >
            Add User
          </button>

        </div>

        {/* SEARCH */}

        <div className="search-section">

          <input
            type="text"
            placeholder="Search by username or role..."
            className="search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

        </div>

        {/* TABLE */}

        <div className="users-table-container">

          <table className="users-table">

            <thead>

              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>

            </thead>

            <tbody>

              {filteredUsers.length === 0 ? (

                <tr>
                  <td colSpan="5" className="no-users">
                    No users found
                  </td>
                </tr>

              ) : (

                filteredUsers.map((user) => (

                  <tr key={user.id}>

                    <td>{user.id}</td>

                    <td>{user.username}</td>

                    <td>
                      <span className={`role-badge ${user.role}`}>
                        {user.role}
                      </span>
                    </td>

                    <td>

                      <button
                        className={`status-toggle ${user.active ? "active" : "inactive"}`}
                        onClick={() => toggleStatus(user.username, user.active)}
                      >
                        {user.active ? "Active" : "Inactive"}
                      </button>

                    </td>

                    <td>

                      <div className="action-buttons">

                        <button
                          className="btn-edit"
                          onClick={() => navigate(`/dashboard/edit-user/${user.id}`)}
                        >
                          Edit
                        </button>

                        <button
                          className="btn-delete"
                          onClick={() => deleteUser(user.id)}
                        >
                          Delete
                        </button>

                      </div>

                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

};

export default ViewUser;